import { render, staticRenderFns } from "./muokkaa-yek-tyoskentelyjaksoa.vue?vue&type=template&id=28c6dc89&scoped=true&"
import script from "./muokkaa-yek-tyoskentelyjaksoa.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-yek-tyoskentelyjaksoa.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-yek-tyoskentelyjaksoa.vue?vue&type=style&index=0&id=28c6dc89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6dc89",
  null
  
)

export default component.exports